/* eslint-disable func-names */
/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable no-use-before-define */
// convert image to object part instead of base64 for better performance
// https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
export const importFileandPreview = (file, revoke) => {
  return new Promise(resolve => {
    window.URL = window.URL || window.webkitURL;
    const preview = window.URL.createObjectURL(file);
    // remove reference
    if (revoke) {
      window.URL.revokeObjectURL(preview);
    }
    setTimeout(() => {
      resolve(preview);
    }, 100);
  });
};

const getVideoThumbnail = (file, videoTimeInSeconds) => {
  return new Promise((resolve, reject) => {
    if (file.type.match("video")) {
      // Add timeout to prevent hanging
      const timeoutId = setTimeout(() => {
        // eslint-disable-next-line no-console
        console.warn("[video-thumb] timeout generating thumbnail", {
          fileType: file.type,
          fileName: file.name,
          videoTimeInSeconds,
        });
        reject(`Timeout generating thumbnail for ${file.type}`);
      }, 10000);

      importFileandPreview(file).then(urlOfFIle => {
        const video = document.createElement("video");

        const timeupdate = function () {
          if (snapImage()) {
            video.removeEventListener("timeupdate", timeupdate);
            video.pause();
          }
        };

        video.addEventListener("loadeddata", function () {
          if (snapImage()) {
            video.removeEventListener("timeupdate", timeupdate);
          }
        });

        const snapImage = function () {
          if (video.videoWidth === 0 || video.videoHeight === 0) {
            return false;
          }

          // Resize the snapshot to a max width of 256px (height proportional) and
          // export as WebP @ q=0.75 — keeps the thumbnail under ~25KB instead of
          // the multi-MB full-resolution PNG the canvas defaulted to.
          const MAX_WIDTH = 256;
          const scale = Math.min(MAX_WIDTH / video.videoWidth, 1);
          const canvas = document.createElement("canvas");
          canvas.width = Math.max(1, Math.round(video.videoWidth * scale));
          canvas.height = Math.max(1, Math.round(video.videoHeight * scale));

          try {
            canvas.getContext("2d").drawImage(video, 0, 0, canvas.width, canvas.height);
            const image = canvas.toDataURL("image/webp", 0.75);

            // Threshold to filter out blank/uniform frames before the video is
            // actually ready. WebM sources fall back to a guessed 10s duration
            // (see getVideoDuration), so frames are less reliable — use a more
            // permissive threshold for them.
            const threshold = file.type.includes("webm") ? 200 : 400;
            const success = image.length > threshold;

            if (success) {
              clearTimeout(timeoutId);
              URL.revokeObjectURL(urlOfFIle);
              resolve(image);
            }
            return success;
          } catch (error) {
            return false;
          }
        };

        video.addEventListener("timeupdate", timeupdate);
        video.preload = "metadata";
        video.src = urlOfFIle;
        video.muted = true;
        video.playsInline = true;
        video.currentTime = videoTimeInSeconds;
        video.play();
      });
    } else {
      reject("file not valid");
    }
  });
};

/**
 *
 * @param videoFile {FIle} // the video file
 * @param numberOfThumbnails {number} //number of thumbnails you want to generate
 * @returns {string[]} // an array of base64 thumbnails images
 *
 * @abstract
 * Idea taken from - https://codepen.io/aertmann/pen/mrVaPx
 * The original functionality of getVideoThumbnail() function is customized as per working code
 * If it didn't work in future then replace it with about links working example
 */
export const generateVideoThumbnails = async (videoFile, numberOfThumbnails) => {
  const thumbnail = [];
  const fractions = [];
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    // eslint-disable-next-line prefer-promise-reject-errors
    if (!videoFile.type?.includes("video")) reject("not a valid video file");
    await getVideoDuration(videoFile).then(async duration => {
      // divide the video timing into particular timestamps in respective to number of thumbnails
      // ex if time is 10 and numOfthumbnails is 4 then result will be -> 0, 2.5, 5, 7.5 ,10
      // we will use this timestamp to take snapshots
      for (let i = 0; i <= duration; i += duration / numberOfThumbnails) {
        fractions.push(Math.floor(i));
      }
      // the array of promises
      const promiseArray = fractions.map(time => {
        return getVideoThumbnail(videoFile, time);
      });
      // console.log('promiseArray', promiseArray)
      // console.log('duration', duration)
      // console.log('fractions', fractions)
      await Promise.all(promiseArray)
        .then(res => {
          res.forEach(res => {
            thumbnail.push(res);
          });
          resolve(thumbnail);
        })
        .catch(err => {
          console.error(err);
          reject(err);
        });
    });
    reject("something went wront");
  });
};

/**
 * Reads the total duration of a video file using only its metadata.
 * Unlike getVideoDuration (which calls play() for thumbnail-seek reliability
 * and hardcodes 10s for WEBM), this is safe for MMS payloads — it never
 * plays the video and resolves to null on any failure so callers can simply
 * omit the field.
 *
 * @deprecated Prefer `getVideoDurationSeconds` / `buildVideoDurationField`
 * from `utils/videoDuration`. This wrapper only reads duration when the
 * BROWSER CAN DECODE the file, which silently fails for iPhone HEVC .mov and
 * on Chromium builds without proprietary codecs. The util parses the container
 * instead and is codec-independent. Kept for any legacy caller.
 *
 * @param videoFile {File}
 * @returns {Promise<number|null>} duration in seconds, or null if unavailable
 */
export const getVideoDurationFromMetadata = videoFile => {
  return new Promise(resolve => {
    if (!videoFile || !videoFile.type || !videoFile.type.match("video")) {
      resolve(null);
      return;
    }
    let settled = false;
    const url = window.URL.createObjectURL(videoFile);
    const video = document.createElement("video");
    const cleanup = () => {
      video.removeEventListener("loadedmetadata", onLoaded);
      video.removeEventListener("durationchange", onLoaded);
      video.removeEventListener("error", onError);
      video.src = "";
      window.URL.revokeObjectURL(url);
    };
    const finish = value => {
      if (settled) return;
      settled = true;
      clearTimeout(timeoutId);
      cleanup();
      resolve(value);
    };
    const onLoaded = () => {
      if (Number.isFinite(video.duration) && video.duration > 0) {
        finish(video.duration);
      }
    };
    const onError = () => finish(null);
    const timeoutId = setTimeout(() => finish(null), 5000);
    video.addEventListener("loadedmetadata", onLoaded);
    video.addEventListener("durationchange", onLoaded);
    video.addEventListener("error", onError);
    video.preload = "metadata";
    video.src = url;
  });
};

/**
 *
 * @param videoFile {File}
 * @returns {number} the duration of video in seconds
 */
export const getVideoDuration = videoFile => {
  return new Promise((resolve, reject) => {
    if (videoFile) {
      if (videoFile.type.match("video")) {
        importFileandPreview(videoFile).then(url => {
          const video = document.createElement("video");

          // For WEBM files, use fallback immediately since they often fail
          if (videoFile.type.includes("webm")) {
            URL.revokeObjectURL(url);
            resolve(10);
            return;
          }

          // Add timeout to prevent hanging for other video types
          const timeoutId = setTimeout(() => {
            URL.revokeObjectURL(url);
            reject("Timeout getting video duration");
          }, 5000);

          const handleDuration = () => {
            clearTimeout(timeoutId);
            // Validate duration before resolving
            if (Number.isFinite(video.duration) && video.duration > 0) {
              URL.revokeObjectURL(url);
              resolve(video.duration);
            } else {
              URL.revokeObjectURL(url);
              reject("Invalid video duration");
            }
          };

          // Listen to multiple events for better compatibility
          video.addEventListener("loadedmetadata", handleDuration);
          video.addEventListener("loadeddata", handleDuration);
          video.addEventListener("durationchange", handleDuration);

          video.preload = "metadata";
          video.src = url;
          video.muted = true;
          video.playsInline = true;
          video.play();
        });
      }
    } else {
      reject(0);
    }
  });
};
